export default __webpack_public_path__ + "static/media/subscriptionPageBg.17e173bb.png";